import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest(
    'get',
    `/api/courses/${id}/teachers`
  ).then((res) => res.data);



// WEBPACK FOOTER //
// ./src/app/services/courses/getTeachers.js